export enum APP_ERROR_CODE {
    INVALID_DATA = 'INVALID_DATA',
    ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
    REQUEST_CANCELLED = 'REQUEST_CANCELLED'
}
